module.exports = __webpack_public_path__ + "static/media/person2.3a568390.jpg";